<div>
    <div class="mb-4 text-xl font-semibold">
        {{ 'components.yearly-amounts.title' | translate }}
    </div>
    <div class="text-sm text-[var(--element-ui-2)] mt-4 mb-6">
        {{ 'components.yearly-amounts.amount-by-year' | translate }}{{ required() ? '*' : '' }}
    </div>

    <div class="flex flex-col gap-6 mt-6">
        @for (yearRow of control().controls; track yearRow.controls.fiscalYear.value; let idx = $index) {
            <div class="flex items-start gap-4">
                <div class="w-60 pt-2 text-white">FY {{ yearRow.controls.fiscalYear.value }}</div>

                <div class="flex-1">
                    <tran-number-input
                        class="form-control text-start"
                        [inputId]="'amount-' + yearRow.controls.fiscalYear.value"
                        [attr.aria-label]="'FY ' + yearRow.controls.fiscalYear.value"
                        [min]="0"
                        [max]="999999999.99"
                        [step]="1000"
                        unit="€"
                        [placeholder]="'components.yearly-amounts.example' | translate"
                        [formControl]="yearRow.controls.amount"
                    />

                    @if (
                        (yearRow.controls.amount.invalid || yearRow.controls.amount.value === null) &&
                        (yearRow.controls.amount.touched || submitted())
                    ) {
                        @if (yearRow.controls.amount.errors?.['numberFormat']) {
                            <div class="mt-2 text-sm text-danger">
                                {{ 'components.yearly-amounts.invalid-format' | translate }}
                            </div>
                        }
                        @if (yearRow.controls.amount.errors?.['required']) {
                            <div class="mt-2 text-sm text-danger">
                                {{ 'application-form.required' | translate }}
                            </div>
                        }
                        @if (yearRow.controls.amount.errors?.['min']) {
                            <div class="mt-2 text-sm text-danger">
                                {{ 'components.yearly-amounts.min0' | translate }}
                            </div>
                        }
                        @if (yearRow.controls.amount.errors?.['max']) {
                            <div class="mt-2 text-sm text-danger">
                                {{
                                    'components.yearly-amounts.max'
                                        | translate: { max: yearRow.controls.amount.errors?.['max']?.max }
                                }}
                            </div>
                        }
                    }
                </div>

                <button
                    type="button"
                    class="btn btn-circle btn-ghost"
                    [attr.aria-label]="
                        'components.yearly-amounts.remove-year' | translate: { year: yearRow.controls.fiscalYear.value }
                    "
                    (click)="removeYear(idx)"
                    [disabled]="control().disabled"
                >
                    <i class="element-delete icon"></i>
                </button>
            </div>
        }
    </div>
    @if (control().length === 0 && control().invalid && control().touched) {
        <div class="mt-2 text-sm text-danger">
            {{ 'application-form.required' | translate }}
        </div>
    }

    <button class="btn btn-tertiary mt-4 pl-0" type="button" (click)="addYear()" [disabled]="control().disabled">
        <i class="icon element-plus"></i>
        {{ 'components.yearly-amounts.add-year' | translate }}
    </button>

    <div class="mt-3 border-t border-white/20"></div>

    <div class="mt-6 flex items-center gap-4">
        <div class="w-60 pt-2 text-white">{{ 'components.yearly-amounts.total' | translate }}</div>
        <div class="flex-1">
            <tran-number-input
                class="font-semibold form-control text-start"
                unit="€"
                [readonly]="true"
                [showButtons]="false"
                [formControl]="totalControl"
                tranSkipTab="input"
            />
        </div>
    </div>
</div>
